export const PORTAL_IDS = {
  BREADCRUMBS_RIGHT_COMPONENT_ID: 'breadcrumbs-right-component',
  APP_HEADER_RIGHT_COMPONENT_ID: 'app-header-right-component',
}
